import { AxiosResponse } from 'axios';

const mapSuccessResponseToState = (
 response: AxiosResponse,
 name: string,
 action: string,
) => ({
 data: response.data,
 rowCount: response.headers['x-total-count'] || 0,
 aggregate: response.headers['Aggregated-Values'] || null,
 message: `${name} ${action} successfully`,
 type: 'success',
});

export { mapSuccessResponseToState };
